var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundLoginlayoutLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#paint0_linear_111_1355)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1682.54 -288C1580.08 -216.839 1513 -98.2947 1513 35.921C1513 253.565 1689.4 430 1907 430C2124.6 430 2301 253.565 2301 35.921C2301 -98.2947 2233.92 -216.839 2131.46 -288H1682.54ZM2063.7 35.921C2063.7 122.484 1993.55 192.657 1907 192.657C1820.45 192.657 1750.3 122.484 1750.3 35.921C1750.3 -50.642 1820.45 -120.815 1907 -120.815C1993.55 -120.815 2063.7 -50.642 2063.7 35.921Z",
    fill: "url(#paint1_linear_111_1355)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1435.5,
    cy: 515.5,
    r: 160.5,
    fill: "url(#paint2_linear_111_1355)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_1355",
    x1: 1920,
    y1: 17.9999,
    x2: 0.00000907741,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339881,
    stopColor: "#E1F1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#F1F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_1355",
    x1: 1907,
    y1: -358.158,
    x2: 1907,
    y2: 430,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114583,
    stopColor: "#0A316F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#485BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28DBF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_1355",
    x1: 1525.55,
    y1: 355,
    x2: 1525.55,
    y2: 676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27B1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#1BE4F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLoginlayoutLogin);
export default __webpack_public_path__ + "static/media/background-loginlayout-login.06789b0f682e88f573402d44428cdbd6.svg";
export { ForwardRef as ReactComponent };